import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AssetsHistoryCard from '../components/assets/AssetHistoryCard';
import { fetchAssetHistory, fetchAssetRequests, LOANED, RETURNED } from '../redux/assets/actions';

function Assets() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isFetchingAssetHistory, triedFetchingAssetHistory } = useSelector((state) => state.system);
  const { selectedUser } = useSelector((state) => state.users);

  useEffect(() => {
    if (!isFetchingAssetHistory && !triedFetchingAssetHistory && selectedUser.myportalUserId != null) {
      dispatch(fetchAssetHistory(selectedUser.myportalUserId, 0, 20, LOANED));
      dispatch(fetchAssetHistory(selectedUser.myportalUserId, 0, 20, RETURNED));
      dispatch(fetchAssetRequests(selectedUser.myportalUserId, 0, 20));
    }
  }, [dispatch, isFetchingAssetHistory, triedFetchingAssetHistory, selectedUser.myportalUserId]);

  const handleViewAllAssets = () => {
    history.push('/assets/all');
  };

  return (
    <div className="container-fluid">
      <div className="row row-dashboard">
        <div className="col-lg-12">
          <div className="mb-3 d-flex justify-content-start">
            <button
              className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
              onClick={handleViewAllAssets}
              style={{ gap: '8px', padding: '8px 16px' }}>
              <i className="fas fa-list"></i> All Assets
            </button>
          </div>
          <AssetsHistoryCard />
        </div>
      </div>
    </div>
  );
}

export default Assets;
